import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cases: []
}

const caseSlice = createSlice({
    name: 'cases',
    initialState,
    reducers: {
        addCase: (state, action) => {
            state.cases = action.payload;
        }
    }
})

export const handleAddCase = (state)=>{
    return dispatch => dispatch(caseSlice.actions.addCase(state))
}

export default caseSlice.reducer